export {
  formatInteger,
  formatCurrency,
  formatPercent,
} from '../FnbAnalyticsWrapper/fnbAnalyticsUtils'

export function formatInventoryValue(value) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  return new Intl.NumberFormat('en-US').format(Math.round(Number(value)))
}

export function formatReportDate(dateKey) {
  if (!dateKey) return '—'
  const parsed = new Date(`${String(dateKey).slice(0, 10)}T12:00:00`)
  if (Number.isNaN(parsed.getTime())) return dateKey
  return parsed.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}

export function eventDefaultReportDate(event) {
  if (!event?.start) return ''
  const parsed = new Date(event.start)
  if (Number.isNaN(parsed.getTime())) return ''
  return parsed.toISOString().slice(0, 10)
}

export function todayReportDate() {
  return new Date().toISOString().slice(0, 10)
}

export function formatSignedPercent(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  const sign = n > 0 ? '+' : ''
  return `${sign}${n.toFixed(1)}%`
}

export function formatSignedInteger(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  const sign = n > 0 ? '+' : ''
  return `${sign}${Math.round(n)}`
}
